import React from "react";
import { BILLABLES_OVERVIEW } from "./constant";
import { usePersistentState } from "@/hooks/use-persistent-state";
import { endOfMonth, startOfMonth } from "date-fns";
import { formatDateForAPI } from "utils/utils";
import { BillablesOverview } from "./components/overview";
import { BillingHealthInsights } from "./components/billing-health-insights";
import { Receivables } from "./components/outstandig-receivables";
import { Highvalue } from "./components/high-value";
import { Scbillables } from "./components/sc-billaables";
import { HighValueProjects } from "./components/high-value-projects";
import { QuarterlyRevenueChart } from "./components/quarterly-revenue-chart";
import { BilledVsCollectedChart } from "@/modules/reports/billables/dashboard/components/billed-vs-collected-chart";

export default function BillablesDashboard() {
  const [state, setState] = usePersistentState({
    endpoint: "billables-dashboard",
    defaultState: {
      dateRange: {
        from: formatDateForAPI(startOfMonth(new Date())),
        to: formatDateForAPI(endOfMonth(new Date())),
      },
    },
  });

  const handleDateRangeChange = (newRange) => {
    setState({
      dateRange: {
        from: newRange?.from,
        ...(newRange?.to ? { to: newRange?.to } : {}),
      },
    });
  };

  return (
    <div className="flex-1">
      <BillablesOverview
        dateRange={state.dateRange}
        onDateRangeChange={handleDateRangeChange}
      />

      <BillingHealthInsights />

      <div className="flex gap-4 mt-6 grid grid-cols-2">
        <section className="mt-3.5">
          <Receivables />
        </section>
        <section className="mt-3.5">
          <Highvalue />
        </section>
      </div>

      <section className="mt-6">
        <Scbillables />
      </section>

      <section className="mt-6">
        <HighValueProjects />
      </section>

      <section className="mt-6">
        <BilledVsCollectedChart />
      </section>
    </div>
  );
}
